const ENTITY_NAME = "Progression Scorecard";
const PAGE_TITLES = {
  create: `Create an entity type`,
  view: `View entity type`,
  list: `Manage entity type`
};
const reduxActionTypePrefix = `progression-scorecard`;
const TriggeredScorecardDefaults = {
  FeatureGateExpression: `"{FeatureGateName}"`
};
var SupportedTriggerType = /* @__PURE__ */ ((SupportedTriggerType2) => {
  SupportedTriggerType2["feature_variant"] = "feature_variant";
  SupportedTriggerType2["feature_gate"] = "feature_gate";
  SupportedTriggerType2["auto_generate"] = "auto_generate";
  SupportedTriggerType2["manual"] = "manual";
  SupportedTriggerType2["no_trigger"] = "no_trigger";
  SupportedTriggerType2["side_stream_manual"] = "side_stream_manual";
  SupportedTriggerType2["custom"] = "custom";
  return SupportedTriggerType2;
})(SupportedTriggerType || {});
const AUTOMATIC_GROUP_HEADER = "Automatic analysis";
export {
  AUTOMATIC_GROUP_HEADER,
  ENTITY_NAME,
  PAGE_TITLES,
  SupportedTriggerType,
  TriggeredScorecardDefaults,
  reduxActionTypePrefix
};
//# sourceMappingURL=module.constants.js.map
